import { Bubble, Props as BubbleProps } from './Bubble';
import { OptionsBubble } from './OptionsBubble';
import { ChoiceType } from '@raysee/schema';

interface Props extends BubbleProps {
  choices?: ChoiceType[];
}

export const ChoiceBubble = ({ choices, ...props }: Props) => (
  <>
    <Bubble {...props}>
      <div className="rounded-2xl border bg-white px-4 py-3 drop-shadow-sm">
        <p className="whitespace-pre-line">{props.message.text}</p>
      </div>
    </Bubble>
    {props.isWaiting && (
      <OptionsBubble {...props} sender={null} displayStatus={false} choices={choices} hideQuestionText={true} />
    )}
  </>
);
